<template>
  <section class="form-fw__content">
    <form
      v-if="status === isSuccess"
      class="form--custom"
      novalidate
      @submit.prevent="handleSubmit"
    >
      <fieldset class="form__container">
        <header v-if="kind === 'cadastrar'" class="form__container__header">
          <h2 class="form__container__title">{{ $t(`${namespace}.formTitle`) }}</h2>
          <p class="form__container__desc">{{ $t(`${namespace}.formDescription`) }}</p>
        </header>

        <div class="form__container__content">
          <div v-if="kind === 'cadastrar'">
            <ul class="steps">
              <li
                v-for="(step, index) in $t(`${namespace}.steps`)"
                :key="`step-${index}`"
                class="steps__item"
              >
                {{ step }}
              </li>
            </ul>

            <label>{{ $t(`${namespace}.fieldRideIdLabel`) }}</label>
            <AutoComplete
              kind="rideCredit"
              :data="rideList"
              :placeholder="$t(`${namespace}.fieldRideIdPlaceholder`)"
              :companyId="globalCompany ? globalCompany.id : null"
              :isValid="isValidRideList"
              required
              @input="updateRideList"
            />
          </div>

          <v-data-table
            v-if="isValidArray(rideTable.body)"
            class="table__ride"
            :headers="rideTable.header"
            :items="rideTable.body"
            hide-actions
          >
            <template v-slot:items="props">
              <td>
                <span
                  v-if="
                    props.item.ride &&
                    props.item.ride.detail &&
                    props.item.ride.detail.start &&
                    props.item.ride.detail.start.date &&
                    props.item.ride.detail.end &&
                    props.item.ride.detail.end.date
                  "
                >
                  <span
                    :title="props.item.ride.detail.start.date | formatDate('DD/MM/YYYY')"
                    class="text--ellipsis"
                  >
                    {{ props.item.ride.detail.start.date | formatDate('DD/MM/YYYY') }}
                  </span>

                  <span class="gray-6--text caption text--ellipsis">
                    {{ $t('Views.FinancialAdjustmentsPage.from') }} {{ props.item.ride.detail.start.date | formatDate('HH:mm') }}
                    {{ $t('Views.FinancialAdjustmentsPage.to') }} {{ props.item.ride.detail.end.date | formatDate('HH:mm') }}
                  </span>
                </span>
                <span v-else>-</span>
              </td>

              <td>
                <span v-if="
                  props.item.ride &&
                  props.item.ride.detail &&
                  props.item.ride.detail.employee &&
                  props.item.ride.detail.employee.name
                ">
                  <span :title="props.item.ride.detail.employee.name" class="text--ellipsis">
                    {{ props.item.ride.detail.employee.name | ellipsis(25) }}
                  </span>
                </span>
                <span v-else class="text--ellipsis">-</span>

                <span v-if="
                  props.item.ride &&
                  props.item.ride.detail &&
                  props.item.ride.detail.employee &&
                  props.item.ride.detail.employee.email
                ">
                  <span :title="props.item.ride.detail.employee.email" class="gray-6--text caption text--ellipsis">
                    {{ props.item.ride.detail.employee.email | ellipsis(25) }}
                  </span>
                </span>
                <span v-else class="gray-6--text caption text--ellipsis">-</span>
              </td>

              <td>
                <span
                  v-if="
                    props.item.ride &&
                    props.item.ride.detail &&
                    props.item.ride.detail.costCenter &&
                    props.item.ride.detail.costCenter.name
                  "
                  :title="props.item.ride.detail.costCenter.name"
                  class="text--ellipsis"
                >
                  {{ props.item.ride.detail.costCenter.name | ellipsis(25) }}
                </span>
                <span v-else>-</span>
              </td>

              <td>
                <span
                  v-if="
                    props.item.ride &&
                    props.item.ride.detail &&
                    props.item.ride.detail.taxiCategoryName
                  "
                  v-html="getRideCategory(props.item.ride.detail.taxiCategoryName)"
                  :title="props.item.ride.detail.taxiCategoryName"
                  class="text--ellipsis"
                />
                <span v-else>-</span>
              </td>

              <td>
                <span
                  v-if="
                    props.item.ride &&
                    props.item.ride.detail &&
                    props.item.ride.detail.odometer
                  "
                  :title="props.item.ride.detail.odometer | metresToKm"
                >
                  {{ props.item.ride.detail.odometer | metresToKm }}
                </span>
                <span v-else>-</span>
                <br>

                <span
                  v-if="
                    props.item.ride &&
                    props.item.ride.detail &&
                    props.item.ride.detail.start &&
                    props.item.ride.detail.start.date &&
                    props.item.ride.detail.end &&
                    props.item.ride.detail.end.date
                  "
                  class="gray-6--text caption"
                  :title="props.item.ride.detail.start.date | durationCalc(props.item.ride.detail.end.date)"
                >
                  {{ props.item.ride.detail.start.date | durationCalc(props.item.ride.detail.end.date) }}
                </span>
                <span v-else>-</span>
              </td>

              <td>
                <span
                  v-if="props.item.ride && props.item.ride.amount"
                  :title="props.item.ride.amount | currencyBRL"
                >
                  {{ props.item.ride.amount | currencyBRL }}
                </span>
                <span v-else>-</span>
              </td>
            </template>
          </v-data-table>

          <v-radio-group
            v-model="form.radioGroup"
            v-validate="{ required: true }"
            :error-messages="errors.collect($t(`Views.FinancialAdjustmentsPage.fieldChargebackName`))"
            :data-vv-name="$t(`Views.FinancialAdjustmentsPage.fieldChargebackName`)"
            :disabled="kind === 'cadastrar' && !isValidArray(rideList)"
            required
            class="mt-0"
          >
            <v-radio :label="$t(`Views.FinancialAdjustmentsPage.totalCreditLabel`)" value="totalCreditLabel"></v-radio>
            <v-radio :label="$t(`Views.FinancialAdjustmentsPage.partialCreditLabel`)" value="partialCreditLabel"></v-radio>
          </v-radio-group>

          <div v-if="form.radioGroup === 'partialCreditLabel'" style="padding-left: 32px;">
            <label>{{ $t(`Views.FinancialAdjustmentsPage.fieldCreditAmountLabel`) }}</label>
            <v-text-field
              v-model="form.creditValue"
              v-money="money"
              ref="creditValue"
              :placeholder="$t(`Views.FinancialAdjustmentsPage.fieldDiscountAmountPlaceholder`)"
              :error-messages="errors.collect($t(`Views.FinancialAdjustmentsPage.fieldDiscountAmount`))"
              v-validate="{
                required: true,
                isValueAllowed: [0, receipt.ride.amount]
              }"
              :data-vv-name="$t(`Views.FinancialAdjustmentsPage.fieldDiscountAmount`)"
              :disabled="kind === 'cadastrar' && !isValidArray(rideList)"
              required
              flat
              outline
              solo
              color="accent"
            />
          </div>

          <label>{{ $t(`Views.FinancialAdjustmentsPage.justification`) }}</label>
          <v-select
            v-model="form.reason"
            item-text="text"
            :placeholder="$t(`Views.FinancialAdjustmentsPage.chooseAnOption`)"
            :items="objectToArray($t(`Views.FinancialAdjustmentsPage.reasonList`))"
            :error-messages="errors.collect($t(`Views.FinancialAdjustmentsPage.justificationName`))"
            v-validate="{ required: true }"
            :data-vv-name="$t(`Views.FinancialAdjustmentsPage.justificationName`)"
            :disabled="kind === 'cadastrar' && !isValidArray(rideList)"
            noDataText=""
            required
            flat
            outline
            solo
            color="accent"
          />

          <div v-if="form.reason === 'other'">
            <label>{{ $t(`Views.FinancialAdjustmentsPage.fieldReasonTextLabel`) }}</label>
            <v-text-field
              v-model="form.reasonText"
              flat
              outline
              solo
              color="accent"
              clearable
              :name="$t(`Views.FinancialAdjustmentsPage.fieldReasonText`)"
              :placeholder="$t(`Views.FinancialAdjustmentsPage.fieldReasonTextPlaceholder`)"
              v-validate="{ required: true }"
              :error-messages="errors.collect($t(`Views.FinancialAdjustmentsPage.fieldReasonText`))"
              :data-vv-name="$t(`Views.FinancialAdjustmentsPage.fieldReasonText`)"
              required
              :disabled="kind === 'cadastrar' && !isValidArray(rideList)"
            />
          </div>
        </div>
      </fieldset>
    </form>

    <div
      v-if="status === isFailed"
      class="text-xs-center mt-5"
    >
      <span>
        {{ $t('Common.genericErrorMsg') }}<br>
        <a
          href="#"
          :title="$t('Common.tryAgain')"
          class="text--link accent--text"
          @click.prevent="$emit('tryAgain')"
        >
          {{ $t('Common.tryAgain') }}.
        </a>
      </span>
    </div>
  </section>
</template>

<script>
import { VMoney } from 'v-money'
import { mapState, mapActions } from 'vuex'
import { STATUS_IS_LOADING, STATUS_SUCCESS, STATUS_FAILED } from 'utils/constants'
import { isArray, isObject, objectToArray, stringToFloat, convertToCoin, getRideCategory, goBack } from 'utils/functions'
import AutoComplete from 'components/AutoComplete'

export default {
  name: 'Form',
  props: {
    kind: {
      type: String
    },
    data: {
      type: Object
    },
    submit: {
      type: Boolean
    },
    status: {
      type: Number
    }
  },
  directives: {
    money: VMoney
  },
  components: {
    AutoComplete
  },
  computed: {
    ...mapState({
      globalCompany: (state) => state.company.selectedCompany,
      companies: ({ session }) => session.user.business.companies,
      isAdmin: ({ session }) => session.user.business.isAdministrator
    }),

    isLoading: () => STATUS_IS_LOADING,
    isSuccess: () => STATUS_SUCCESS,
    isFailed: () => STATUS_FAILED
  },
  data () {
    return {
      namespace: 'Views.RideCreditPage',
      isFetching: false,
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        precision: 2,
        masked: false
      },
      isValidRideList: true,
      receipt: null,
      rideList: [],
      rideTable: {
        header: [
          {
            text: 'Data',
            value: 'date',
            sortable: false
          },
          {
            text: 'Nome/e-mail',
            value: 'nameEmail',
            sortable: false
          },
          {
            text: 'Centro de custo',
            value: 'costCenter',
            sortable: false
          },
          {
            text: 'Categoria',
            value: 'category',
            sortable: false
          },
          {
            text: 'Distância/tempo',
            value: 'distance',
            sortable: false
          },
          {
            text: 'Valor',
            value: 'value',
            sortable: false
          }
        ]
      },

      // form fields
      form: {
        ridesIds: [],
        radioGroup: null,
        creditValue: null,
        value: null,
        reason: null,
        reasonText: null
      }
    }
  },
  methods: {
    ...mapActions({
      successAlert: 'snackbarAlert/success',
      errorAlert: 'snackbarAlert/error',
      showAlert: 'snackbar/show'
    }),

    isValidArray: (val) => isArray(val),

    isValidObject: (val) => isObject(val),

    objectToArray: (val) => objectToArray(val),

    convertToMoney () {
      this.form.value = stringToFloat(this.form.creditValue)
    },

    prevPage () {
      goBack()
    },

    renderPayload () {
      const arrRides = this.data.receipt ? [{ ...this.data.receipt }] : []
      const data = arrRides
        .filter(item => item.orderId)
        .map(item => ({
          id: item.id,
          name: item.detail.apiInfo.apiTaxiJobId,
          apiTaxiJobId: item.detail.apiInfo.apiTaxiJobId,
          ride: item
        }))

      if (this.validateAutoComplete(data)) {
        this.rideList = data
        this.rideTable.body = data
        this.form.ridesIds = data.map(item => item.id)
        this.isValidRideList = true
      }

      // receipt
      this.receipt = {
        ...this.data.receipt,
        ride: { ...this.data.receipt }
      }

      // chargeback type
      this.form.radioGroup = this.data.credit.value < this.data.receipt.amount
        ? 'partialCreditLabel'
        : 'totalCreditLabel'

      // reason
      const hasReasonList = this.objectToArray(this.$t('Views.FinancialAdjustmentsPage.reasonList')).find((reason) => reason.text === this.data.credit.reason)

      if (hasReasonList) {
        this.form.reason = this.data.credit.reason
        this.form.reasonText = null
      } else {
        this.form.reason = 'other'
        this.form.reasonText = this.data.credit.reason
      }

      // credit value
      this.form.creditValue = convertToCoin(this.data.credit.value)
      const $creditValue = this.$refs['creditValue']
      if ($creditValue) {
        $creditValue.$el.querySelector('input').value = convertToCoin(this.data.credit.value)
      }
    },

    validateAutoComplete (val) {
      const isArray = Array.isArray(val) && val.length
      const isObject = val && typeof val === 'object' && Object.keys(val).length
      return Boolean(isArray || isObject)
    },

    updateRideList (val) {
      const value = this.isValidObject(val) ? [{ ...val }] : []
      this.receipt = val

      if (this.validateAutoComplete(value)) {
        this.rideList = value
        this.rideTable.body = value
        this.form.ridesIds = value.map(item => item.id)
        this.isValidRideList = true
        return
      }

      this.rideList = []
      this.rideTable.body = []
      this.form.ridesIds = []
      this.isValidRideList = false
    },

    getRideCategory (category) {
      return getRideCategory(this, category).text
    },

    async createCredit () {
      this.$emit('setCurrentStatus', this.isLoading)

      try {
        const serviceReceiptId = this.receipt.id
        const amount = this.receipt.ride.amount
        const value = this.form.radioGroup === 'totalCreditLabel' ? amount : this.form.value
        const reason = this.form.reason === 'other' ? this.form.reasonText : this.form.reason

        const { data: res } = await this.$apiService.createCredit(serviceReceiptId, {
          value,
          reason
        })

        if (!res.valid) {
          const error = this.isValidArray(res.reasons) ? res.reasons[0] : res.message
          this.showAlert({
            type: 'error',
            message: error || this.$t(`${this.namespace}.createErrorMessage`)
          })
        } else {
          const message = this.$t(`${this.namespace}.createSuccessMessage`)
            .replace('[RIDE_VALUE]', convertToCoin(value))
            .replace('[RIDE_ID]', this.receipt.apiTaxiJobId)

          scrollTo(0, 0)
          this.showAlert({ type: 'success', message })

          this.$router.push({
            name: 'FinancialAdjustments',
            query: { tab: 2 }
          })
        }

        this.$emit('setCurrentStatus', this.isSuccess)
      } catch (err) {
        console.log('ERROR:', err)
        this.$emit('setCurrentStatus', this.isFailed)
        this.errorAlert(this.$t(`${this.namespace}.createErrorMessage`))
      }
    },

    async editCredit () {
      this.$emit('setCurrentStatus', this.isLoading)

      try {
        const creditId = this.data.credit.id
        const amount = this.receipt.ride.amount
        const value = this.form.radioGroup === 'totalCreditLabel' ? amount : this.form.value
        const reason = this.form.reason === 'other' ? this.form.reasonText : this.form.reason

        const { data: res } = await this.$apiService.updateCredit(creditId, {
          value,
          reason
        })

        if (!res.valid) {
          const error = this.isValidArray(res.reasons) ? res.reasons[0] : res.message
          this.showAlert({
            type: 'error',
            message: error || this.$t(`${this.namespace}.editErrorMessage`)
          })
        } else {
          const message = this.form.radioGroup === 'totalCreditLabel'
            ? this.$t(`${this.namespace}.totalCreditSuccessMessage`)
            : this.$t(`${this.namespace}.partialCreditSuccessMessage`)

          scrollTo(0, 0)
          this.showAlert({ type: 'success', message })
        }

        this.$emit('setCurrentStatus', this.isSuccess)
      } catch (err) {
        console.log('ERROR:', err)
        this.$emit('setCurrentStatus', this.isFailed)
        this.errorAlert(this.$t(`${this.namespace}.editErrorMessage`))
        scrollTo(0, 0)
      }
    },

    async handleSubmit () {
      try {
        const isValid = await this.$validator.validateAll()

        // autocomplete for validation
        if (!this.isValidArray(this.rideList)) this.isValidRideList = false

        if (
          isValid &&
          this.isValidArray(this.rideList)
        ) {
          this.convertToMoney()

          this.kind === 'editar'
            ? this.editCredit()
            : this.createCredit()
        } else {
          const target = this.$validator.errors.items[0]
          if (target) {
            const elem = this.$el.querySelector(`[data-vv-name="${target.field}"]`)
            if (elem) {
              elem.scrollIntoView(false)
              elem.focus()
            }
          }
        }
      } catch (err) {
        console.log('ERROR', err)
      }
    }
  },
  watch: {
    kind () {
      this.renderPayload()
    },

    submit () {
      this.handleSubmit()
    },

    'form.radioGroup' (val) {
      // radioGroup
      // totalCreditLabel
      // partialCreditLabel
      if (val === 'totalCreditLabel') {
        this.form.value = this.receipt && this.receipt.ride && this.receipt.ride.amount
          ? this.receipt.ride.amount
          : 0
        this.form.creditValue = null

        if (this.$refs['creditValue']) {
          this.$refs['creditValue'].$el.querySelector('input').value = 0
        }
      }
    },

    'form.reason' (val) {
      if (val !== 'other') {
        this.form.reasonText = null
      }
    },

    data () {
      this.renderPayload()
    }
  },
  created () {
    this.$validator.extend('isValueAllowed', {
      getMessage: (field, params, data) => {
        const message = this.$t(`${this.namespace}.minAndMaxValueValidationMessage`)
          .replace('[MIN_VALUE]', '{1}')
          .replace('[MAX_VALUE]', '{2}')
        return message
      },
      validate (value, params) {
        const [min = 0, max = 0] = params
        return stringToFloat(value) > Number(min) && stringToFloat(value) <= Number(max)
      }
    })
  }
}
</script>

<style lang="scss" scoped>
.steps {
  list-style-type: none;
  margin-bottom: 25px;
  padding: 0;
  position: relative;

  &:before {
    border-left: 1px solid $accent-2;
    bottom: 10px;
    content: '';
    left: 5px;
    position: absolute;
    top: 10px;
    z-index: 1;
  }
}

.steps__item {
  padding-left: 20px;
  position: relative;

  &:before {
    background-color: $accent-2;
    border: 3px solid $primary;
    border-radius: 50%;
    content: '';
    display: block;
    height: 11px;
    left: 0;
    position: absolute;
    top: 5px;
    width: 11px;
  }
}
</style>

<style lang="scss">
.table__ride {

  .text--ellipsis {
    padding-right: 0;
  }

  > .v-table__overflow {
    border: 1px solid $gray-3;
    border-radius: 4px;
    margin-bottom: 20px;

    > .theme--light.v-table {

      thead > tr {
        background-color: $gray-3;
        border-bottom: none;
        border-radius: 4px;
        height: auto;
        overflow: hidden;

        > th {
          color: $gray-7;
          font-size: 12px;
          padding: 4px;
        }
      }

      tbody > tr {
        border-bottom: 1px solid $gray-3;
        height: auto;

        &:last-child { border-bottom: none; }
        &:nth-child(odd) { background-color: $gray-2; }
        &:nth-child(even) { background-color: #fff; }

        &:hover {
          background-color: darken($gray-2, 2);
        }

        > td {
          padding: 4px;
        }
      }
    }
  }
}
</style>
